import React, { memo } from 'react'
import { Skeleton } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { TEST_IDS } from '../../constants'
import { useCarrierApplicationNameQuery } from './graphql/CarrierApplicationName'

export interface ICarrierApplicationNameTitleProps {
  carrierApplicationId: string
}

const CarrierApplicationNameTitle = memo<ICarrierApplicationNameTitleProps>(
  ({ carrierApplicationId }) => {
    /**
     * Carrier Application Name Query
     */
    const { data, loading } = useCarrierApplicationNameQuery({
      variables: { id: carrierApplicationId },
    })
    const { carrierApplication } = data || {}
    const { name: carrierApplicationName } = carrierApplication || {}

    return (
      <Box mb={3} data-test={TEST_IDS.carrierApplicationTitle}>
        <Box mb={1}>
          <Typography variant='subtitle1'>Carrier</Typography>
        </Box>
        {loading && <Skeleton variant='rectangular' height='27px' width='200px' />}
        {!loading && <Typography variant='body2'>{carrierApplicationName}</Typography>}
      </Box>
    )
  }
)

export default CarrierApplicationNameTitle
